// From https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
// Can't use modern implementation with <=IE11
export default function triggerCustom(targetEl: HTMLElement | Document, name: string): void {
	const myEvent: Event = document.createEvent('Event');
	myEvent.initEvent(name, true, true);

	targetEl.dispatchEvent(myEvent);
}
